<template>
  <div v-if="!pending" class="tailwind">
    <PropertyHeroPriceInfo
      :hotelCode="hotelCode"
      :isExternalHotel="isExternalHotel"
      :showCalendarButton="showCalendarButton"
      :memberOnlyRate="memberOnlyRate"
      :minimunDate="minimumDate"
      @open-price-calendar="onOpenPriceCalendar"
    />
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import {
  PropertyHeroPriceInfo,
  useAnalytics,
  useQueryParamsToSbValues
} from '@common/lib-vue-common'
import { startUpLabels } from './composables/useLabels.js'

const pending = ref(true)
const hotelCode = window.appGlobalProps.hotelCode
const isExternalHotel = window.appGlobalProps.isExternalHotel
  ? window.appGlobalProps.isExternalHotel === 'Yes'
  : false
const memberOnlyRate = window.appGlobalProps.memberOnlyRate === 'true'
const showCalendarButton = window.appGlobalProps.showCalendarButton === 'true'
const minimumDate = window.appGlobalProps.minimumDate
const adultsOnly = window.appGlobalProps.adultsOnly === 'true'

const { trackEvent } = useAnalytics()

const onOpenPriceCalendar = () => {
  trackEvent('click_check_price_calendar')
  window.searchBarVue.$emit('show-price-calendar', {
    hotelCode,
    origin: 'calendar.we',
    adultsOnly
  })
}

onMounted(async () => {
  await startUpLabels()
  pending.value = false
})
</script>
